import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function CfgLeftCornerChartReduce() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Reduce:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[X, i, l]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[A -> X •α, i, l]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>A -> X α ∈ P</span></div>
    </div>)
}
